import React, { useState } from "react";
import { Eye, EyeOff, Sun, Moon } from "lucide-react";
import { stileSfondoApp } from "./style";

// Variabili di tema minime per la schermata di login (mostrata PRIMA che il
// resto dell'app monti il suo <style> completo, vedi src/style.js). Importa
// qui i font Google (Inter/Roboto Mono) usati in tutta l'app: la prima volta
// che carica in sessione è proprio questa schermata.
export const STILE_LOGIN = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Roboto+Mono:wght@400;500;600;700&display=swap');
  [data-theme="light"] { color-scheme: light; --cf-bg-page:#f8fafc; --cf-bg-card:#ffffff; --cf-bg-subtle:#f1f5f9; --cf-border:#e2e8f0; --cf-border-strong:#cbd5e1; --cf-text-primary:#1e293b; --cf-text-muted:#64748b; --cf-text-faint:#94a3b8; --cf-text-heading:#334155; --cf-accent:#1e3a8a; --cf-shadow:rgba(0,0,0,0.05); --cf-danger-text:#b91c1c; }
  [data-theme="dark"] { color-scheme: dark; --cf-bg-page:#0f172a; --cf-bg-card:#1e293b; --cf-bg-subtle:#263449; --cf-border:#334155; --cf-border-strong:#475569; --cf-text-primary:#f1f5f9; --cf-text-muted:#94a3b8; --cf-text-faint:#64748b; --cf-text-heading:#e2e8f0; --cf-accent:#60a5fa; --cf-shadow:rgba(0,0,0,0.4); --cf-danger-text:#f87171; }
  .cf-btn { transition: filter .15s ease, background-color .15s ease, color .15s ease, transform .1s ease, box-shadow .15s ease; }
`;

export default function SchermataLogin({ onLogin, temaScuro, onToggleTema }) {
  const [azienda, setAzienda] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [mostraPassword, setMostraPassword] = useState(false);
  const [errore, setErrore] = useState("");
  const [inCorso, setInCorso] = useState(false);

  const invia = async () => {
    if (!username || !password || inCorso) return;
    setInCorso(true);
    setErrore("");
    try {
      await onLogin(azienda, username, password);
    } catch (e) {
      setErrore(e.message || "Utente o password non validi.");
    } finally {
      setInCorso(false);
    }
  };

  const inputStyle = {
    width: "100%", boxSizing: "border-box", padding: "11px 14px", borderRadius: "8px",
    border: "1px solid var(--cf-border-strong)", backgroundColor: "var(--cf-bg-subtle)",
    color: "var(--cf-text-primary)", fontSize: "14px", outline: "none",
  };

  return (
    <div
      data-theme={temaScuro ? "dark" : "light"}
      style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px", fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", ...stileSfondoApp(temaScuro) }}
    >
      <style>{STILE_LOGIN}</style>
      <button
        className="cf-btn"
        onClick={onToggleTema}
        title="Tema chiaro/scuro"
        style={{ position: "fixed", top: "18px", right: "18px", padding: "8px", borderRadius: "8px", border: "1px solid var(--cf-border)", backgroundColor: "var(--cf-bg-card)", color: "var(--cf-text-primary)", cursor: "pointer", display: "flex", alignItems: "center" }}
      >
        {temaScuro ? <Sun size={18} strokeWidth={2} /> : <Moon size={18} strokeWidth={2} />}
      </button>
      <div style={{ width: "100%", maxWidth: "380px", backgroundColor: "var(--cf-bg-card)", border: "1px solid var(--cf-border)", borderRadius: "12px", boxShadow: "0 10px 40px rgba(0,0,0,0.25)", overflow: "hidden" }}>
        <div style={{ background: "linear-gradient(180deg, #334155 0%, #475569 100%)", padding: "26px 28px", display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img src="/logo.png" alt="Logo" style={{ height: "40px", width: "auto" }} />
            <span style={{ fontFamily: "'Montserrat', 'Segoe UI', sans-serif", fontSize: "19px", lineHeight: 1, marginTop: "1px", color: "#f1f5f9" }}>
              <span style={{ fontWeight: 800 }}>w</span>
              <span style={{ fontWeight: 300 }}>Pulse</span>
            </span>
          </div>
          <div>
            <div style={{ color: "#f1f5f9", fontSize: "18px", fontWeight: 700, fontFamily: "'Roboto Mono', Consolas, monospace", letterSpacing: "0.5px" }}>
              Connector
            </div>
            <div style={{ color: "#cbd5e1", fontSize: "12px", marginTop: "3px" }}>Accesso riservato</div>
          </div>
        </div>
        <div style={{ padding: "26px 28px" }}>
          <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "var(--cf-text-muted)", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Azienda</label>
          <input
            value={azienda}
            autoFocus
            autoComplete="organization"
            onChange={(e) => setAzienda(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") invia(); }}
            style={{ ...inputStyle, marginBottom: "16px" }}
          />
          <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "var(--cf-text-muted)", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Utente</label>
          <input
            value={username}
            autoComplete="username"
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") invia(); }}
            style={{ ...inputStyle, marginBottom: "16px" }}
          />
          <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "var(--cf-text-muted)", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Password</label>
          <div style={{ position: "relative" }}>
            <input
              type={mostraPassword ? "text" : "password"}
              value={password}
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") invia(); }}
              style={{ ...inputStyle, paddingRight: "46px" }}
            />
            <button
              type="button"
              className="cf-btn"
              onClick={() => setMostraPassword((v) => !v)}
              title={mostraPassword ? "Nascondi password" : "Mostra password"}
              tabIndex={-1}
              style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", border: "none", background: "transparent", cursor: "pointer", padding: "4px", lineHeight: 0, display: "flex", alignItems: "center", color: mostraPassword ? "var(--cf-accent)" : "var(--cf-text-faint)" }}
            >
              {mostraPassword ? <EyeOff size={18} strokeWidth={2} /> : <Eye size={18} strokeWidth={2} />}
            </button>
          </div>
          {errore && <div style={{ color: "var(--cf-danger-text)", fontSize: "13px", marginTop: "14px" }}>{errore}</div>}
          <button
            className="cf-btn"
            onClick={invia}
            disabled={inCorso || !username || !password}
            style={{ width: "100%", marginTop: "22px", padding: "12px", borderRadius: "8px", border: "none", backgroundColor: "#1e3a8a", color: "#fff", cursor: (inCorso || !username || !password) ? "not-allowed" : "pointer", fontSize: "14px", fontWeight: 700, opacity: (inCorso || !username || !password) ? 0.6 : 1 }}
          >
            {inCorso ? "Accesso…" : "Accedi"}
          </button>
        </div>
      </div>
    </div>
  );
}
